import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Toggle.scss';
export const toggleName = 'Toggle';
export const toggleTagName = 'cell-component-toggle';
export const toggleChangeEvent = 'change';
export class Toggle extends Component {
    elements;
    constructor() {
        super(toggleName);
        const inputElement = this.querySelector('input');
        if (!inputElement) {
            throw new Error('Input element not found');
        }
        this.elements = {
            input: inputElement,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.elements.input.subscribe('change', this.handleInputChange);
    }
    handleInputChange() {
        this.publish(toggleChangeEvent, { checked: this.elements.input.checked });
    }
}
defineComponent(toggleTagName, Toggle);
